module.exports = __webpack_public_path__ + "img/folder_2@2x.654733be.svg";